module.exports = __webpack_public_path__ + "media/components/signup/static/surf_image_2-adcff4e1a3a2ca76559f103226d4c228.webp";